import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { CommonDesktopSidebarComponent } from './common/components/common-desktop-sidebar/common-desktop-sidebar.component';
import { FaqsComponent } from './common/components/faqs/faqs.component';
import { HttpClientModule } from '@angular/common/http';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UiStyleService } from './common/services/ui-style.service';
import { StorageHandlerService } from './common/services/storage-handler.service';
import { FormsModule } from '@angular/forms';
import { LoadingComponent } from './loading/loading.component';

export function themeFactory(themeService: UiStyleService) {
  return () => themeService.setThemeOnStart();
}


@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent,
    CommonDesktopSidebarComponent,
    FaqsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule
  ],
  providers: [StorageHandlerService,UiStyleService,
    {
      provide: APP_INITIALIZER,
      useFactory: themeFactory,
      deps: [UiStyleService],
      multi: true,
    },
],
  bootstrap: [AppComponent]
})
export class AppModule { }
